import type { ResponseData_Array_OrganizationDocumentResponse } from '@acme/api';
import { OrganizationService } from '@acme/api/client';
import { PaginatedList } from '@shared/ui/paginatedList';
import { useMemo } from 'react';
import { DocumentsEmptyState } from '../../lib/documentsemptystate';
import type { OrganizationDocumentsFiltersValue } from '../../lib/filtertypes';
import { getDocumentDateRange } from '../../lib/filtertypes';
import { OrganizationDocumentsTable } from './table';

type OrganizationDocumentsListProps = {
  filters: OrganizationDocumentsFiltersValue;
};

export const OrganizationDocumentsList = ({
  filters,
}: OrganizationDocumentsListProps) => {
  const params = useMemo(() => {
    const { dateFrom, dateTo } = getDocumentDateRange(filters.period);
    return {
      documentTypeIds: filters.documentTypeId
        ? [filters.documentTypeId]
        : undefined,
      dateFrom,
      dateTo,
    };
  }, [filters]);

  return (
    <PaginatedList
      method={OrganizationService.getApiV1OrganizationFiles1}
      params={params}
      extract={(response: ResponseData_Array_OrganizationDocumentResponse) => ({
        items: response.data ?? [],
        totalCount: (response.data ?? []).length,
      })}
      loadingFallback={
        <div className="bg-white border border-gray-200 rounded-lg p-12 text-center text-gray-500">
          Загрузка…
        </div>
      }
    >
      {(items) =>
        items.length === 0 ? (
          <DocumentsEmptyState />
        ) : (
          <OrganizationDocumentsTable documents={items} />
        )
      }
    </PaginatedList>
  );
};
